import type { ProductType } from '@hc-frontend/core-types';
import { ProductType as ProductTypeSchema } from '@hc-frontend/core-types';
import type { InsurancePlanQuoteContextEntity } from '@hc-frontend/features-tracking';
import { InsurancePlanQuoteContextSchema } from '@hc-frontend/features-tracking';
import type { SelfDescribingJson } from '@snowplow/browser-tracker';

import type { PlanSummaryEntity } from '../domain';

export function buildInsurancePlanQuoteContext({
  planSummary,
  productType,
}: {
  planSummary: PlanSummaryEntity;
  productType: ProductType;
}): SelfDescribingJson<InsurancePlanQuoteContextEntity> {
  let contextProduct: InsurancePlanQuoteContextEntity['product'];
  switch (productType) {
    case ProductTypeSchema.Enum.MEDICARE_ADVANTAGE:
      contextProduct =
        InsurancePlanQuoteContextSchema.shape.product.Enum.medicare_advantage;
      break;
    case ProductTypeSchema.Enum.MEDICARE:
    default:
      contextProduct =
        InsurancePlanQuoteContextSchema.shape.product.Enum.medicare_supplement;
      break;
  }
  return {
    schema: 'iglu:com.healthcare/insurance_plan_quote/jsonschema/1-0-0',
    data: {
      internal_id: planSummary.id,
      name: planSummary.title,
      carrier: planSummary.carrier,
      product: contextProduct,
      type: planSummary.planType,
      metal_level:
        planSummary.metalLevel as InsurancePlanQuoteContextEntity['metal_level'],
      rating: planSummary.rating,
    },
  };
}
